export default __webpack_public_path__ + "static/media/user-feed2.7f28cad0.png";